
import { FooterWrapper } from '../HelperComponents/StyledComponents';









import React, {
  Component,
  Fragment
} from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import LogoImg from '../../images/logo.png';

import PropTypes from 'prop-types';

import {
  NavLink
} from 'react-router-dom';


import { logOutAction } from '../../actions/UserActions';


class FooterComponent extends Component {

  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object
  }

  render() {

    return (
    <FooterWrapper className="">
    <div className="container">
      <section className="columns is-mobile is-centered">
        <section className="column is-narrow">
          {this.props.user.authenticated &&
          <figure className="image" style={{ width: '26px' }}>
            <img src={LogoImg} style={{ filter: 'brightness(0) invert(1)' }} alt="Voila Footer Logo"/>
          </figure>
          }
        </section>
      </section>
    </div>
  </FooterWrapper>
    );
  }
}









function mapStateToProps(state) {
  const { user } = state;
  const {
    isFetching,
    lastUpdated,
  } = user || {
    isFetching: true,
    authenticated: false
  };

  return {
    user,
    isFetching,
    lastUpdated
  };
}

export const Footer = withRouter(connect(mapStateToProps, { logOutAction })(FooterComponent));


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js